import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET } from "../../services/axios.service";
import { RootState } from "../../app/store";
import {
  CategoriesProps,
  CategoryDateBy,
  CategorySortBy,
  CategorySortOrder,
} from "../../types/category";

export interface CategoriesState {
  categories: CategoriesProps[];
  totalCategories: number;
  isCategoryModalOpen: boolean;
  editCategory: CategoriesProps | null;
  loading: boolean;
  error: string | null;
}

const initialState: CategoriesState = {
  categories: [],
  totalCategories: 0,
  isCategoryModalOpen: false,
  editCategory: null,
  loading: false,
  error: null,
};

type FetchCategoriesListDataProps = {
  page: number;
  size?: number;
  fromDate?: string | null;
  toDate?: string | null;
  search?: string | null;
  date_by?: CategoryDateBy;
  sort_by?: CategorySortBy;
  sort_order?: CategorySortOrder;
};

export const fetchCategoriesListData = createAsyncThunk(
  "fetchCategoriesListData",
  async (req: FetchCategoriesListDataProps) => {
    let response: any;
    await GET(`/v1/admin/categories`, { ...req })
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    toggleCategoryModal: (state, action: PayloadAction<boolean>) => {
      state.isCategoryModalOpen = action.payload;
    },
    setEditCategory: (state, action: PayloadAction<CategoriesProps | null>) => {
      state.editCategory = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCategoriesListData.pending, (state, action: any) => {
      state.categories = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchCategoriesListData.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload.data.status === "success") {
        state.categories = action.payload.data.data.records;
        state.totalCategories = action.payload.data.data.total_records;
        state.error = null;
      } else {
        state.categories = [];
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    });
    builder.addCase(fetchCategoriesListData.rejected, (state, action: any) => {
      state.categories = [];
      state.loading = false;
      state.error =
        action?.payload?.data?.message ||
        "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
    });
  },
});

export const { toggleCategoryModal, setEditCategory } =
  categoriesSlice.actions;

export const getCategories = (state: RootState) =>
  state.categories.categories;

export const getTotalCategories = (state: RootState) =>
  state.categories.totalCategories;

export const getIsCategoryModalOpen = (state: RootState) =>
  state.categories.isCategoryModalOpen;

export const getEditCategory = (state: RootState) =>
  state.categories.editCategory;

export default categoriesSlice.reducer;
